import React, { useState, memo } from 'react';
import ActionButton from './ActionButton';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import Singleton from '../../../core/singleton';

const ListItem = props => {
    const { getTradByKey } = Singleton.getInstance();
    const [currentManipulatedOrder, setCurrentManipulatedOrder] = useState({ id: null });
    /** tell if the manipulated order is the previous one (used for the popover instance )  */
    const theCurrentActionOrderIsThatOne = id => (currentManipulatedOrder && (currentManipulatedOrder.id === id));
    /** toggle the manipulated order  */
    const onPopOverToggle = order => {
        if (order.id !== currentManipulatedOrder.id)
            setCurrentManipulatedOrder(order);
        else
            setCurrentManipulatedOrder({ id: null });
    }
    return <div className="col-12 form-group" >
        <div className="row bg-transparent pt-3 pb-3 shadow border-top align-items-center" onClick={event => {
            event.stopPropagation();
            if (event.target.type !== "submit") {
                props.showListProductOfOrder(props.order);
            }
        }}>
            <div className="col col-md-2 cursor-pointer" >
                <h6>{distanceInWordsToNow(props.order.created_at, { includeSeconds: true, addSuffix: true })}</h6>
            </div>
            <div className="col col-md-2 text-md-center cursor-pointer" >
                <h6>{props.order.seat}</h6>
                <h6 className="d-none d-sm-block cursor-pointer">{props.order.first_name[0]}. {props.order.last_name}</h6>
            </div>
            <div className="col col-md-2 d-none d-md-block cursor-pointer">
                <ul className="list-group list-group-flush cursor-pointer" >
                    {
                        props.order.cart.products.slice(0, 2).map((product, index) => <li key={index} className="list-group-item text-truncate">{product.title}</li>)
                    }
                    {
                        (props.order.cart.products.length > 1) &&
                        <li className="list-group-item text-truncate">...</li>
                    }
                </ul>
            </div>
            <div className="col col-md-2 text-center cursor-pointer"><h6>{props.order.total_paid}{props.order.currency.symbol}</h6></div>
            <div className="col col-md-2 d-none d-md-block text-center cursor-pointer"><h6 className="text-truncate">{getTradByKey(`places.${props.order.status}`)}</h6></div>
            <div className="align-items-md-center col col-md-2 d-flex text-center">
                <ActionButton
                    label={props.order.status}
                    ordersWorkflow={props.ordersWorkflow}
                    onChange={status => props.onStatusChange(status, props.order)}
                    id={`btn-orders-${props.order.id}`}
                    open={theCurrentActionOrderIsThatOne(props.order.id) ? true : false}
                    onToggle={() => onPopOverToggle(props.order)} />
            </div>
        </div>
    </div>;
}
export default memo(ListItem)